import httpClient from '../api/httpClient'

export const updateUserInfo = async (payload) => {
  const endpoint = 'refusers/update'
  return httpClient.put(endpoint, payload)
}

export const addCommentEntity = async (payload) => {
  const endpoint = '/refcomments/create'
  return httpClient.post(endpoint, payload)
}

export const updateCommentEntity = async (payload) => {
  const endpoint = '/refcomments/update'
  return httpClient.put(endpoint, payload)
}

export const deleteCommentEntity = async (payload) => {
  const endpoint = '/refcomments/delete'
  return httpClient.delete(endpoint, { data: { Id: payload }})
}

export const likeEntity = async (payload) => {
  const endpoint = 'refusers/createLike'
  return httpClient.post(endpoint, payload)
}

export const unlikeEntity = async (payload) => {
  const endpoint = 'refusers/deleteLike'
  return httpClient.delete(endpoint, { data: { Id: payload }})
}

export const getMyMemories = async (payload) => {  
  const endpoint = `refdeceaseds/getmanymy?Limit=${payload.limit}&PageNumber=${payload.pageIndex}&IsHuman=${payload.isHuman}&FirstName=${payload.name || ''}&LastName=${payload.surname || ''}`
  return httpClient.get(endpoint)
}

export const getPendingRequests = async (payload) => {
  const endpoint = `/refFollowingInvitation/getmanypendingrequest?followerId=${payload.currentUser}&limit=${payload.limit}&pageNumber=${payload.pageIndex}`
  return httpClient.get(endpoint)
}

export const updateUserTheme = async (payload) => {
  const endpoint = '/refusers/UpdateUserTheme'
  return httpClient.put(endpoint, payload)
}

export const getMySendRequests = async (payload) => {
  const endpoint = '/pendingrequests/' + payload + '/byuser'
  return httpClient.get(endpoint)
}

export const declineRequest = async (payload) => {
  const endpoint = '/reffollowinginvitation/delete'
  return httpClient.delete(endpoint, { data: { Id: payload }})
}

export const acceptRequest = async (payload) => {
  const endpoint = '/RefFollowingInvitation/update'
  return httpClient.put(endpoint, payload)
}

export default {
  updateUserInfo,
  getMyMemories,
  getMySendRequests,
  getPendingRequests,
  declineRequest,
  updateUserTheme,
  acceptRequest,
  likeEntity,
  unlikeEntity
}
